export default {
  message: null,
  color: null,
  active: false,
};
